import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
};

const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    setAuthStatus: (state, action) => {
      if (action.payload === 1) {
        state.isAuthenticated = true;
      } else {
        state.isAuthenticated = false;
      }
    },
  },
});

export const { setAuthStatus } = roleSlice.actions;
export default roleSlice.reducer;
